import KeyboardNavigation from '../../grid/keyboardNavigation';

export default instance => {
  instance.ext.inlineEditors.attachEvent('onBeforeSave', ({ id, columnName }) => {
    KeyboardNavigation.setCurrentEditingRowAndColumnIndices(id, columnName);

    return true;
  });
};
